/**
 * b2b-portal.js — V2
 *
 * ÄNDERUNG GEGENÜBER V1: initDealerSelection() suchte die Dashboard-URL
 * bisher über ein Attribut auf <body> — das kollidierte mit der neuen
 * Section-Struktur. Jetzt wird stattdessen das umschließende
 * .b2b-dealer-list-wrap-Element gelesen (siehe
 * sections/b2b-haendlerauswahl.liquid).
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'b2b_acting_as_dealer';

  // ---------- Teil 0: Header-Abstand messen (läuft auf jeder Portal-Seite) ----------
  function initHeaderSpacer() {
    var spacers = document.querySelectorAll('[data-b2b-header-spacer]');
    if (!spacers.length) return;

    // Versucht mehrere gängige Header-Selektoren, da der exakte Aufbau je
    // nach Theme-Version variiert. Passt bei Bedarf den ersten Treffer an,
    // falls euer Header einen anderen Wrapper/ID/Klasse nutzt.
    var candidates = [
      '#shopify-section-header',
      '.shopify-section-header',
      'header.header',
      'header[role="banner"]',
      'header'
    ];

    var headerEl = null;
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el && el.offsetHeight > 0) {
        headerEl = el;
        break;
      }
    }

    function applyHeight() {
      var height = headerEl ? headerEl.offsetHeight : 80; // Fallback wie in CSS
      document.documentElement.style.setProperty('--b2b-header-height', height + 'px');
    }

    applyHeight();
    window.addEventListener('resize', applyHeight);

    // Falls der Header z. B. durch einen Cookie-Banner nachträglich seine
    // Höhe ändert, nochmal nach kurzer Verzögerung neu messen.
    setTimeout(applyHeight, 500);
  }

  // ---------- Teil 1: Händlerauswahl-Seite ----------
  function initDealerSelection() {
    var rows = document.querySelectorAll('[data-b2b-dealer-row]');
    if (!rows.length) return;

    var wrap = document.querySelector('.b2b-dealer-list-wrap');
    var dashboardUrl = (wrap && wrap.getAttribute('data-b2b-dashboard-url'))
      || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      || '/';

    rows.forEach(function (row) {
      var toggleBtn = row.querySelector('[data-b2b-dealer-toggle]');
      var confirmBox = row.querySelector('[data-b2b-dealer-confirm]');
      var confirmBtn = row.querySelector('[data-b2b-dealer-confirm-btn]');
      var input = row.querySelector('[data-b2b-dealer-kdnr-input]');
      var errorEl = row.querySelector('[data-b2b-dealer-error]');
      var expectedKdnr = (row.dataset.kdnr || '').trim().toLowerCase();
      var firma = row.dataset.firma || '';

      if (toggleBtn && confirmBox) {
        toggleBtn.addEventListener('click', function () {
          var isHidden = confirmBox.hasAttribute('hidden');
          confirmBox.toggleAttribute('hidden', !isHidden);
        });
      }

      if (confirmBtn) {
        confirmBtn.addEventListener('click', function () {
          if (input) {
            var entered = (input.value || '').trim().toLowerCase();
            if (entered !== expectedKdnr) {
              if (errorEl) errorEl.removeAttribute('hidden');
              return;
            }
          }
          try {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
              kdnr: row.dataset.kdnr,
              firma: firma
            }));
          } catch (e) {
            /* sessionStorage evtl. blockiert - dann ohne Persistenz fortfahren */
          }
          window.location.href = dashboardUrl;
        });
      }
    });

    var searchInput = document.querySelector('[data-b2b-dealer-search]');
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var q = searchInput.value.trim().toLowerCase();
        rows.forEach(function (row) {
          var haystack = row.dataset.search || '';
          row.style.display = haystack.indexOf(q) === -1 ? 'none' : '';
        });
      });
    }
  }

  // ---------- Teil 2: "Im Auftrag von"-Anzeige auf Portal-Seiten ----------
  function initAdmContext() {
    var shell = document.querySelector('[data-b2b-shell]');
    if (!shell || shell.dataset.isAdm !== 'true') return;

    var admBar = document.querySelector('[data-b2b-adm-bar]');
    var nameEl = document.querySelector('[data-b2b-adm-dealer-name]');
    var kdnrEl = document.querySelector('[data-b2b-adm-dealer-kdnr]');

    var stored = null;
    try {
      stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    } catch (e) {
      stored = null;
    }

    if (!stored || !stored.kdnr) {
      if (admBar) {
        var switchLink = document.querySelector('[data-b2b-adm-switch]');
        if (switchLink) {
          window.location.href = switchLink.getAttribute('href');
        }
      }
      return;
    }

    if (admBar) {
      admBar.removeAttribute('hidden');
    }
    if (nameEl) nameEl.textContent = stored.firma;
    if (kdnrEl) kdnrEl.textContent = stored.kdnr;
  }

  // ---------- Teil 3: Artikelliste - Suche/Filter ----------
  function initArticleSearch() {
    var input = document.querySelector('[data-b2b-article-search]');
    var rows = document.querySelectorAll('[data-b2b-article-row]');
    var emptyMsg = document.querySelector('[data-b2b-article-empty]');
    if (!input || !rows.length) return;

    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var visibleCount = 0;
      rows.forEach(function (row) {
        var match = (row.dataset.search || '').indexOf(q) !== -1;
        row.style.display = match ? '' : 'none';
        if (match) visibleCount++;
      });
      if (emptyMsg) emptyMsg.toggleAttribute('hidden', visibleCount !== 0);
    });
  }

  // ---------- Teil 4: "Zur Anfrage" - Ajax Cart API ----------
  function initAddToAnfrage() {
    var buttons = document.querySelectorAll('[data-b2b-add-to-anfrage]');
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('tr');
        var qtyInput = row ? row.querySelector('[data-b2b-article-qty]') : null;
        var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        var variantId = btn.dataset.variantId;

        btn.disabled = true;
        var originalText = btn.textContent;
        btn.textContent = 'Wird hinzugefügt …';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart add failed');
            return res.json();
          })
          .then(function () {
            btn.textContent = 'Hinzugefügt';
            updateCartCount();
            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1500);
          })
          .catch(function () {
            btn.textContent = 'Fehler – erneut versuchen';
            btn.disabled = false;
          });
      });
    });
  }

  // ---------- Teil 5: Sidebar-Badge mit echter Anfragekorb-Anzahl ----------
  function updateCartCount() {
    var badge = document.querySelector('[data-b2b-cart-count]');
    if (!badge) return;
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        badge.textContent = cart.item_count;
      })
      .catch(function () { /* still showing last known value */ });
  }

  // ---------- Teil 6: Anfragekorb - Mengen/Entfernen über Ajax Cart API ----------
  function initCartRows() {
    var rows = document.querySelectorAll('[data-b2b-cart-row]');
    if (!rows.length) return;

    function changeQuantity(lineKey, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: quantity })
      }).then(function (res) {
        if (!res.ok) throw new Error('cart change failed');
        return res.json();
      });
    }

    rows.forEach(function (row) {
      var key = row.dataset.lineKey;
      var input = row.querySelector('[data-b2b-qty-input]');
      var decBtn = row.querySelector('[data-b2b-qty-decrease]');
      var incBtn = row.querySelector('[data-b2b-qty-increase]');
      var removeBtn = row.querySelector('[data-b2b-cart-remove]');

      function applyQuantity(newQty) {
        if (newQty < 1) newQty = 1;
        input.value = newQty;
        changeQuantity(key, newQty).then(function () {
          window.location.reload();
        });
      }

      if (decBtn) decBtn.addEventListener('click', function () {
        applyQuantity((parseInt(input.value, 10) || 1) - 1);
      });
      if (incBtn) incBtn.addEventListener('click', function () {
        applyQuantity((parseInt(input.value, 10) || 1) + 1);
      });
      if (input) input.addEventListener('change', function () {
        applyQuantity(parseInt(input.value, 10) || 1);
      });
      if (removeBtn) removeBtn.addEventListener('click', function () {
        changeQuantity(key, 0).then(function () {
          window.location.reload();
        });
      });
    });
  }

  // ---------- Teil 7: Anfragekorb - Standardkonditionen-Checkbox ----------
  function initDeviationNote() {
    var checkbox = document.querySelector('[data-b2b-standard-confirm]');
    var note = document.querySelector('[data-b2b-deviation-note]');
    if (!checkbox || !note) return;
    function sync() {
      note.toggleAttribute('hidden', checkbox.checked);
    }
    checkbox.addEventListener('change', sync);
    sync();
  }

  // ---------- Teil 8: Anfragekorb - Prioritäts-Auswahl (nur ADM) ----------
  function initPriorityPills() {
    var pills = document.querySelectorAll('[data-b2b-priority]');
    if (!pills.length) return;
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
      });
    });
  }

  // ---------- Teil 9: Anfragekorb - "Anfrage senden" ----------
  function generateRequestKey() {
    if (window.crypto && window.crypto.randomUUID) {
      return window.crypto.randomUUID();
    }
    return 'req-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  function initSendAnfrage() {
    var btn = document.querySelector('[data-b2b-send-anfrage]');
    if (!btn) return;
    var statusEl = document.querySelector('[data-b2b-send-status]');
    var requestKey = generateRequestKey();
    var alreadySent = false;

    btn.addEventListener('click', function () {
      if (alreadySent) {
        if (statusEl) statusEl.textContent = 'Anfrage wurde bereits gesendet.';
        return;
      }

      var checkbox = document.querySelector('[data-b2b-standard-confirm]');
      var deviationInput = document.querySelector('[data-b2b-deviation-input]');
      var activePriorityEl = document.querySelector('[data-b2b-priority].is-active');
      var admContext = null;
      try {
        admContext = JSON.parse(sessionStorage.getItem('b2b_acting_as_dealer') || 'null');
      } catch (e) { admContext = null; }

      var payload = {
        request_key: requestKey,
        standardkonditionen_bestaetigt: checkbox ? checkbox.checked : true,
        abweichung_hinweis: deviationInput ? deviationInput.textContent.trim() : '',
        prioritaet: activePriorityEl ? activePriorityEl.dataset.b2bPriority : 'normal',
        ueber_adm: !!admContext,
        adm_haendler: admContext
      };

      if (!btn.dataset.endpoint) {
        if (statusEl) {
          statusEl.textContent = 'Anfrage-Versand noch nicht konfiguriert (kein Endpunkt hinterlegt).';
          statusEl.className = 'b2b-send-status is-error';
        }
        return;
      }

      btn.disabled = true;
      if (statusEl) {
        statusEl.textContent = 'Anfrage wird gesendet …';
        statusEl.className = 'b2b-send-status';
      }

      fetch(btn.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Anfrage-Endpunkt nicht erreichbar (Status ' + res.status + ')');
          return res.json().catch(function () { return {}; });
        })
        .then(function () {
          alreadySent = true;
          if (statusEl) {
            statusEl.textContent = 'Anfrage gesendet. Vielen Dank!';
            statusEl.className = 'b2b-send-status is-success';
          }
        })
        .catch(function (err) {
          btn.disabled = false;
          if (statusEl) {
            statusEl.textContent = 'Anfrage-Versand fehlgeschlagen (' + err.message + ').';
            statusEl.className = 'b2b-send-status is-error';
          }
        });
    });
  }

  // ---------- Teil 10: Downloads - Produktfamilien-Filter ----------
  function initDownloadFilter() {
    var select = document.querySelector('[data-b2b-download-family-filter]');
    var rows = document.querySelectorAll('[data-b2b-download-row]');
    if (!select || !rows.length) return;

    select.addEventListener('change', function () {
      var fam = select.value;
      rows.forEach(function (row) {
        var rowFam = row.dataset.family || 'alle';
        var match = fam === 'alle' || rowFam === fam || rowFam === 'alle';
        row.style.display = match ? '' : 'none';
      });
    });
  }

  // ---------- Teil 11: Kontaktformular - Formtyp-Pillen ----------
  function initFormtypPills() {
    var pills = document.querySelectorAll('[data-b2b-formtyp]');
    var hiddenInput = document.querySelector('[data-b2b-formtyp-input]');
    if (!pills.length || !hiddenInput) return;

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        hiddenInput.value = pill.dataset.b2bFormtyp;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeaderSpacer();
    initDealerSelection();
    initAdmContext();
    initArticleSearch();
    initAddToAnfrage();
    updateCartCount();
    initCartRows();
    initDeviationNote();
    initPriorityPills();
    initSendAnfrage();
    initDownloadFilter();
    initFormtypPills();
  });
})();
